import { useQuery } from "@apollo/client";
import { useProductCatalogContext } from "../ProductCatalogContext";
import { ATTRIBUTE_COMPANY_COUNT_QUERY } from "./queries";
import { NumberCard } from "../components/NumberCard";
import { COMPANY_SEARCH_CLIENT } from "../../../utils/consts";

export const CompanyCountCard = (props: { attributeId: number }) => {
  const { entityTypeFilterValue, localizeInstalls } =
    useProductCatalogContext();
  const { data, loading } = useQuery(ATTRIBUTE_COMPANY_COUNT_QUERY, {
    variables: {
      attributeId: props.attributeId,
      localizeInstalls,
      ...entityTypeFilterValue,
    },
    skip: props.attributeId === 0,
    context: { clientName: COMPANY_SEARCH_CLIENT },
  });

  return (
    <NumberCard
      id="company-count"
      isLoading={loading}
      count={data?.opportunityGeneratorSearch.count || 0}
      title="Number of Companies"
    />
  );
};
